import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { catchError, map, Observable, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';

export class FollowerApi {
  private apiUrl = environment.API_URL;

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getFollowerAgeCount(
    type: string,
    startDateEpochMillis: number,
    endDateEpochMillis: number
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/follower/followers/age-count?type=${type}&startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getFollowerGenderCount(
    type: string,
    startDateEpochMillis: number,
    endDateEpochMillis: number
  ): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/follower/followers/gender?type=${type}&startDateEpochMillis=${startDateEpochMillis}&endDateEpochMillis=${endDateEpochMillis}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(response => {
          return response;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
